import { useEffect, useRef, useState } from "react";

function prefersReducedMotion() {
  if (typeof window === "undefined" || !window.matchMedia) {
    return true;
  }
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

export function AnimatedNumber({
  value,
  duration = 780,
  className = "",
}: {
  value: number;
  duration?: number;
  className?: string;
}) {
  const [display, setDisplay] = useState(value);
  const previous = useRef(value);

  useEffect(() => {
    if (prefersReducedMotion()) {
      const timeout = window.setTimeout(() => {
        previous.current = value;
        setDisplay(value);
      }, 0);
      return () => window.clearTimeout(timeout);
    }

    let frame = 0;
    let animation = 0;
    const start = previous.current;
    const delta = value - start;
    const totalFrames = Math.max(1, Math.round(duration / 16));

    const tick = () => {
      frame += 1;
      const progress = Math.min(1, frame / totalFrames);
      const eased = 1 - Math.pow(1 - progress, 3);
      const next = Math.round(start + delta * eased);
      setDisplay(next);
      if (progress < 1) {
        animation = window.requestAnimationFrame(tick);
      } else {
        previous.current = value;
      }
    };

    animation = window.requestAnimationFrame(tick);
    return () => window.cancelAnimationFrame(animation);
  }, [duration, value]);

  return <span className={`tabular ${className}`}>{display}</span>;
}
